/** API route map: URLS.Controller.GlobalSearch */
export const GlobalSearch = {
      Name: 'GlobalSearch/',
      Search: 'search',
};
